import Immutable from 'immutable';
import { User } from './User';

export interface RawComment {
  id: string;
  issueid: string;
  projectid: string;
  comment: string;
  user: User;
  date: number;
  clientmodifiedtimestamp: number;
}

export interface RawCommentResponse {
  comments: RawComment[];
  cursor: string;
}

export interface RawDeleteCommentResponse {
  successful: boolean;
  comment: RawComment;
}

export interface RawEditCommentResponse {
  successful: boolean;
  comment: RawComment;
}

export interface CommentData {
  id: string;
  issueid: string;
  projectid: string;
  comment: string;
  user: User;
  date: number;
  clientmodifiedtimestamp: number;
}

const defaultValues: CommentData = {
  id: '',
  issueid: '',
  projectid: '',
  comment: '',
  user: new User(),
  date: 0,
  clientmodifiedtimestamp: 0,
};

export const CommentFactory = Immutable.Record(defaultValues, 'Comment');

export class Comment extends CommentFactory {
  static deserialize(rawComment: RawComment): Comment {
    return new Comment({
      ...rawComment,
    });
  }

  serialize(): RawComment {
    return this.toJS();
  }
}

export type CommentList = Immutable.List<Comment>;

export type CommentMap = Immutable.OrderedMap<string, Comment>;
